module.exports = __webpack_public_path__ + "19900d943d7c2d6971668dc290838216.svg";